// HTTP status of a failed API call. utils/api.ts rejects error responses as
// Error({ cause: status }); ky throws HTTPError (response.status) when the
// response has no message. Network and chain-read errors have no status.
export const httpStatusOf = (error: unknown): number | undefined => {
  const { cause, response } = (error ?? {}) as { cause?: unknown; response?: { status?: unknown } };
  if (typeof cause === 'number') return cause;
  return typeof response?.status === 'number' ? response.status : undefined;
};

// Default query retry: once for 5xx, 408, 429 and errors without a status
// (network); never for other 4xx. ky already retried a GET 408/5xx once.
export const shouldRetryQuery = (failureCount: number, error: unknown) => {
  const status = httpStatusOf(error);
  return failureCount < 1 && (status === undefined || status === 408 || status === 429 || status >= 500);
};

// A 429 waits 10 s; other errors keep the React Query default backoff.
export const queryRetryDelay = (failureCount: number, error: unknown) =>
  httpStatusOf(error) === 429 ? 10_000 : Math.min(1000 * 2 ** failureCount, 30_000);
